module.exports = __webpack_public_path__ + "img/zc-07.1ab058ed.svg";